import React from 'react';
import { Card } from '@avila-tek/ui';
import { FormHeader } from '../../shared/Forms';
import { ACTIONS } from '../../dashboard/GoalsDashboard/reducer';

interface PointsProps {
  pointsBalance?: number;
  pointsAssigned?: number;
  pointsRedeemed: number;
}

function Points({
  pointsBalance,
  pointsAssigned,
  pointsRedeemed,
}: PointsProps) {
  return (
    <Card className="w-full flex">
      <FormHeader title="Puntos" />
      <Card.Body>
        <div className=" flex flex-col lg:flex-row w-full">
          <div className="w-full lg:w-1/2 px-2 flex flex-col text-gray-300">
            <label className="block ">
              <span className="text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider ">
                Saldo de puntos disponibles
              </span>
              <div className="w-full border-[0.5px] border-solid border-neutral-300 rounded flex items-center py-2 px-3 gap-4 font-bold text-xl">
                <input
                  className={`  focus:ring-0 border-none appearance-none h-6 bg-transparent outline-none focus:outline-none focus:shadow-none w-full placeholder:text-neutral-400 tracking-wider p-0 font-bold text-xl ${
                    pointsBalance <= 0 ? 'text-red-500' : 'text-green-500'
                  }`}
                  name={ACTIONS.TOTAL_POINTS_BALANCE}
                  type="text"
                  value={pointsBalance}
                  disabled
                />
              </div>
            </label>
          </div>
          <div className="w-full lg:w-1/2 px-2">
            <label className="block ">
              <span className="text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider ">
                Puntos asignados a beneficiarios
              </span>
              <div className="w-full border-[0.5px] border-solid border-neutral-300 rounded flex items-center py-2 px-3 gap-4 font-bold text-xl">
                <input
                  className={`  focus:ring-0 border-none appearance-none h-6 bg-transparent outline-none focus:outline-none focus:shadow-none w-full placeholder:text-neutral-400 tracking-wider p-0 font-bold text-xl`}
                  name={ACTIONS.TOTAL_PONITS_ASSIGNED}
                  type="text"
                  value={pointsAssigned}
                  disabled
                />
              </div>
            </label>
          </div>
          <div className="w-full lg:w-1/2 px-2">
            <label className="block ">
              <span className="text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider ">
                Puntos redimidos por beneficiarios
              </span>
              <div className="w-full border-[0.5px] border-solid border-neutral-300 rounded flex items-center py-2 px-3 gap-4 font-bold text-xl">
                <input
                  className={`  focus:ring-0 border-none appearance-none h-6 bg-transparent outline-none focus:outline-none focus:shadow-none w-full placeholder:text-neutral-400 tracking-wider p-0 font-bold text-xl`}
                  name={ACTIONS.TOTAL_PONITS_REDEEMED}
                  type="text"
                  value={pointsRedeemed}
                  disabled
                />
              </div>
            </label>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default Points;
